<template>
  <!-- :class="backgroundClass" -->
  <v-app :class="backgroundClass">
    <Header v-if="!$store.state.meetSta" :key="$store.state.headerfullname"/>
    <!-- <Header v-if="$store.getters['isLogin']" /> -->
 
     <MenuMainpage v-if="$store.state.navMenuMainpage" />
    <MenuMainpagePolicy v-if="$store.state.navMenuMainpagePolicy" />
    <MenuMainpageSwitchLanguage v-if="$store.state.navMenuMainpageSwitchLanguage" />
    <Menu v-if="$store.state.navMenu" />
    
    <Content />
    <Fotter  v-if="$store.state.loadFooter" />
  </v-app>
</template>

<script>
import HeaderResponsive from "@/components/core/HeaderResponsive.vue";
import HeaderisLogin from "@/components/core/HeaderisLogin.vue";
import Header from "@/components/core/Header.vue";
import Menu from "./components/core/Menu.vue";
import MenuMainpage from "./components/core/MenuMainpage.vue";
import Content from "./components/core/Content.vue";
import Fotter from "./components/core/Fotter.vue";
import { feature } from "@/services/constants";
import MenuMainpagePolicy from "./components/core/MenuMainpagePolicy.vue";
import MenuMainpageSwitchLanguage from "./components/core/MenuMainpageSwitchLanguage.vue";

export default {
  name: "app",
  components: {
    HeaderResponsive,
    HeaderisLogin,
    Header,
    MenuMainpage,
    MenuMainpagePolicy,
    MenuMainpageSwitchLanguage,
    Menu,
    Content,
    Fotter,
  },
   computed: {
    backgroundClass() {
      if(this.$route.path == '/my-data-rights-form' || this.$route.path == '/login-account' || this.$route.path == '/joinmeetid' 
      || this.$route.path == '/forgot-password' || this.$route.path == '/reset-password' || this.$route.path == '/register-account'
      || this.$route.path == '/contact'){
        return 'bg-contact-bg';
      }else if(this.$route.path == '/'){
        // return 'bg-home-background';
         return '';
      }else if(this.$route.path == '/about' ){
        return 'bg-about-background';
      }else if( this.$route.path == '/pricing'){
        return 'bg-about-background';
      }else{
        return 'bg-default-background';
      }
     },
  },
  beforeCreate() {
    // localStorage.setItem(feature.LANGUAGE, "en");
     if (localStorage.getItem(feature.LANGUAGE) === "en") {
      localStorage.setItem(feature.LANGUAGE, "gb");
    }
    if (!localStorage.getItem(feature.LANGUAGE)) {
      localStorage.setItem(feature.LANGUAGE, "gb");
    }


  },
  mounted() {
    this.$store.dispatch({ type: "restoreLogin" });
    // this.openExternalBrowserIfLine();
     if (!sessionStorage.getItem('appOpened') && (!localStorage.getItem("rememberme") || localStorage.getItem("rememberme") == "false")) {
      // this.onFirstAppOpen()
      sessionStorage.setItem('appOpened', 'true')
    }
  },
   methods: {
    onFirstAppOpen() {
      console.log('แอพเปิดครั้งแรก');
       this.$store.dispatch("doLogout");
    },
    openExternalBrowserIfLine() {
    const userAgent = navigator.userAgent || '';
    const isLine = /Line\//i.test(userAgent);
    console.log(userAgent)
    console.log(isLine)
    
    if (isLine) {
      const url = window.location.href;
      
      // ถ้ายังไม่มี openExternalBrowser=1 ใน URL ให้ redirect
      if (!url.includes('openExternalBrowser=1')) {
        const separator = url.includes('?') ? '&' : '?';
        window.location.replace(url + separator + 'openExternalBrowser=1');
      }
    }
  },
  },
  data() {
    return {};
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@200;400&display=swap");


.v-application {
    font-family: Arial;
    /* font-family: "Kanit", serif; */
}
.v-application.v-application--is-ltr.theme--light{
  font-family: Arial;
  /* font-family: "Kanit", serif; */
}
.swal2-title {
    font-family: Arial;
    font-size: 24px !important;
}
.swal2-html-container {
    font-family: Arial;
}
#app a {
  font-weight: bold;
  color: #078fc3;
}
/* #zmmtg-root {
  display: none;
  position: none;
} */
input[type=text]:focus {
    outline: none !important;
    outline-offset: none !important;
}

/* body{
  overflow: auto;
} */
/* html, body {
  overflow: auto !important;
} */
input[type=text]:focus {
    outline: 0px solid rgba(0,0,0,0) !important;
    outline-offset: 0px !important;
}
/* .v-main {
   background-color:lightblue;
} */
/* .theme--light.v-application {
  background-image: linear-gradient(to right top, #cbe9f8, #dcedfc, #ebf2fd, #f7f8fe, #ffffff) !important;
} */

 .bg-contact-bg {
  /* background-image: url('/public/contact-bg.png') !important; */
  background-color:#FFFFFF !important;
  /* background-size: cover !important; */
   background-size: 100% 100%  !important;
   /* background-position: center !important;
  background-repeat: no-repeat !important; */
  /* background-size: 100% 100% !important; */
  /* background-position: 100% 100% !important; */
  /* min-height: 100vh !important; */
}
 .bg-home-background {
  background-image: url('/public/home-background.png') !important;
  /* background-size: cover !important; */
  background-size: 100% 100% !important;
  /* background-position: 100% 100% !important; */
  /* min-height: 100vh !important; */
}
 .bg-about-background {
  /* background-image: url('/public/about-bg.png') !important; */
  background:#FFFFFF !important;
  /* background-size: cover !important; */
  background-size: 100% 100% !important;
  /* background-position: 100% 100% !important; */
  /* min-height: 100vh !important; */
}
 .bg-default-background {
  /* background:#FAFAFA !important; */
  background:#FFFFFF !important;
  /* background-size: cover !important; */
  background-size: 100% 100% !important;
  /* background-position: 100% 100% !important; */
  /* min-height: 100vh !important; */
}

  @media only screen and (max-width: 599px)  {
  .bg-contact-bg {
    background-color:#FFFFFF !important;
  /* background-image: url('/public/contact-bg-mobile.png') !important; */
  /* background-size: cover !important; */
   background-size: 100% 100%  !important;
  /* background-position: center !important;
  background-repeat: no-repeat !important; */
}
  .bg-home-background {
  background-image: url('/public/home-background-mobile.png') !important;
   background-size: 100% 100%  !important;
}
 .bg-about-background {
  /* background-image: url('/public/about-bg-mobile.png') !important; */
  background:#FFFFFF !important;
  /* background-size: cover !important; */
  background-size: 100% 100% !important;
  /* background-position: 100% 100% !important; */
  /* min-height: 100vh !important; */
}
}


/* .v-main__wrap {
   background-image: url('/public/home-background.png') !important;
  background-size: cover !important;
} */

 .custom-padding-form {
  padding:0 !important;
}

/* หน้าจอตั้งแต่ขนาด sm (>=600px) ขึ้นไป */
@media (min-width: 600px) {
  .custom-padding-form {
    padding:0 2rem !important;
  }
}

.slide-btn {
  background-color: #215295 !important;
  overflow: hidden;
  position: relative;
  z-index: 0;
  border-radius: 8px;
}

.slide-btn::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;  
  width: 100%;
  height: 0%;  
  background-color: #3068D0;
  transition: height 0.35s ease-in-out;
  z-index: -1;
  border-color: #3068D0;   
}
.slide-btn:hover {
  color: #FFFFFF !important;
  border-color: #3068D0 !important;   
}
.slide-btn:hover::after {
  height: 100%;    
}

.section-title {
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  line-height: 1.2;
}

.section-desc {
  font-size: 0.95rem;
  line-height: 1.75;
  opacity: 0.9;
}

/* #zego-container{
    font-size: 18px;
    font-family: Arial, sans-serif;
} */
</style>
